<template>
	<MobileLayout>
		<MobileHeader :logoColor="'white'" />

		<!-- 自然撑开的内容区，无固定高度 -->
		<div class="page-content">
			<section class="m-hero">
				<div class="m-hero-track" ref="heroTrack">
					<div v-for="(img, i) in heroImages" :key="i" class="m-hero-slide">
						<img :src="img" alt="Product" />
					</div>
				</div>
			</section>

			<section class="m-info font-apercu-medium">
				<div class="m-title">{{ productName }}</div>
				<div class="m-specs">
					<div class="m-spec-row">
						<span class="m-spec-label">Dimension</span>
						<span class="m-spec-value">
							L {{ product.DimensionLength }}
							<span style="margin: 0px 15px;">
								W {{ product.DimensionWidth }}
							</span>
							H {{ product.DimensionHeight }}
						</span>
					</div>
					<div class="m-spec-row">
						<span class="m-spec-label">Material</span>
						<span class="m-spec-value">{{ productMaterial }}</span>
					</div>
					<div class="m-spec-row">
						<span class="m-spec-label">Color</span>
						<span class="m-spec-value">{{ productFinish }}</span>
					</div>
				</div>
				<div v-if="showSizeRange" class="m-specs">
					<div class="m-spec-row">
						<span class="m-spec-label">Minimum Size</span>
						<span class="m-spec-value">
							L {{ product.MinimumLength }}
							<span style="margin: 0px 15px;">
								W {{ product.MinimumWidth }}
							</span>
							H {{ product.MinimumHeight }}
						</span>
					</div>
					<div class="m-spec-row">
						<span class="m-spec-label">Maximum Size</span>
						<span class="m-spec-value">
							L {{ product.MaximumLength }}
							<span style="margin: 0px 15px;">
								W {{ product.MaximumWidth }}
							</span>
							H {{ product.MaximumHeight }}
						</span>
					</div>
				</div>
			</section>

			<section class="m-actions font-apercu-medium">
				<div class="m-actions-bar">
					<textarea ref="customInput" v-model="customMessage" class="m-action-input" rows="1"
						placeholder="Customise..." @input="resizeInput"></textarea>
					<button class="m-action-solid" @click="enquire">Enquire</button>
				</div>
			</section>
		</div>

		<MobileFooter style="margin-top: 60rem;margin-bottom: 80rem;" />
	</MobileLayout>
</template>

<script>
	import MobileLayout from '@/components/mobile/MobileLayout.vue'
	import MobileFooter from '@/components/mobile/footer.vue'
	import MobileHeader from '@/components/mobile/header.vue'
	import {
		getProductDetail
	} from '@/api/product'
	import {
		getUser
	} from '@/config/auth'
	import {
		addToCart
	} from '@/api/Enquiry'
	import {
		addToLocalCart
	} from '@/utils/localCart'

	const placeholderImage = require('@/assets/Group 1-2.png')
	const brandLogo = require('@/assets/mobile/home/logo.png')

	export default {
		name: 'MobileProductDetail',
		components: {
			MobileLayout,
			MobileFooter,
			MobileHeader
		},
		data() {
			return {
				loading: false,
				product: {},
				brandLogo,
				customMessage: '',
				heroImages: [],
				showSizeRange: false,
			}
		},
		computed: {
			productName() {
				return this.product.ProductName || 'Product Detail'
			},
			productMaterial() {
				return this.product.Material || 'Custom material'
			},
			productFinish() {
				return this.product.Color || 'Custom finish'
			},
			productSize() {
				const p = this.product
				if (!p.DimensionLength && !p.DimensionWidth && !p.DimensionHeight) return 'Made to order'
				const parts = []
				if (p.DimensionLength) parts.push(`L ${p.DimensionLength}    `)
				if (p.DimensionWidth) parts.push(`W ${p.DimensionWidth}   `)
				if (p.DimensionHeight) parts.push(`H ${p.DimensionHeight}`)
				return parts.join(' ')
			}
		},
		mounted() {
			this.fetchDetail()
			this.$nextTick(() => {
				this.resizeInput()
			})
			window.scrollTo(0, 0)
		},
		methods: {
			// 在 methods 中新增
			scrollPageToTop() {
			  // this.$nextTick(() => {
			  //   const container = document.querySelector('.m-content')
			  //   if (container) {
			  //     container.scrollTop = 0
			  //   }
			  // })
			   window.scrollTo({ top: 0, behavior: 'smooth' });
			    // 或强制立即滚动
			    document.documentElement.scrollTop = 0;
			    document.body.scrollTop = 0;
			},
			resetHeroScroll() {
				this.$nextTick(() => {
					if (this.$refs.heroTrack) {
						this.$refs.heroTrack.scrollTop = 0;
					}
				});
			},
			resizeInput() {
				const el = this.$refs.customInput
				if (!el) return
				el.style.height = 'auto'
				el.style.height = el.scrollHeight + 'px'
			},
			async fetchDetail() {
				const productId = this.$route.params.id;
				if (!productId) {
					this.showMessage('error', 'Product ID missing');
					return;
				}

				this.loading = true;
				try {
					const response = await getProductDetail(productId, 'mobile');
					const detail = response.result || response;
					if (!detail) {
						this.showMessage('error', 'Product not found');
						return;
					}
					this.product = detail;
					console.log(detail)
					this.updateHeroImages();
					this.resetHeroScroll();
					
					// ✅ 数据渲染后滚动到顶部
					this.scrollPageToTop();
				} catch (error) {
					console.error('Failed to load product detail:', error);
					this.showMessage('error', 'Failed to load product');
				} finally {
					this.loading = false;
				}
			},
			updateHeroImages() {
				const images = []
				const product = this.product

				if (product.Images && product.Images.length) {
					product.Images.forEach(img => {
						if (img.ImageURL && img.ImageType !== 'main') {
							images.push(img.ImageURL)
						}
					})
				} else if (product.image) {
					images.push(product.image)
				}

				if (images.length === 0) images.push(placeholderImage)
				if (images.length === 1) images.push(images[0])
				this.heroImages = images
			},
			showMessage(type, message) {
				window.dispatchEvent(
					new CustomEvent('app-message', {
						detail: {
							type,
							title: type === 'success' ? 'Success' : 'Error',
							message
						}
					})
				)
			},
			getMainImage() {
				if (!this.product.Images || this.product.Images.length === 0) {
					return ''
				}
				const mainImage = this.product.Images.find(img => img.ImageType === 'main')
				return mainImage ? mainImage.ImageURL : this.product.Images[0].ImageURL || ''
			},
			async enquire() {
				const user = getUser()
				if (!user) {
					const imageUrl = this.getMainImage()
					const success = addToLocalCart(
						this.product.ProductID,
						this.customMessage,
						imageUrl,
						this.product.CategoryName || '',
						this.product.ProductName
					)
					if (success) {
						this.$router.push('/m/enquiry')
						this.customMessage = ''
					} else {
						this.showMessage('error', 'Product already in enquiry list')
					}
					return
				}
				const model = {
					ProductID: this.product.ProductID,
					UserID: user.UserID,
					CustomisationText: this.customMessage || ''
				}
				try {
					const response = await addToCart(model)
					if (response.retCode === 1) {
						this.$router.push('/m/enquiry')
						this.customMessage = ''
					} else {
						this.showMessage('error', response.retMsg || 'Add to cart failed')
					}
				} catch (error) {
					console.error('Add to cart error:', error)
					this.showMessage('error', 'Network error, please try again')
				}
			}
		}
	}
</script>

<style scoped>
	.m-hero {
		height: 460rem;
		overflow: hidden;
		border-bottom: 1rem solid #000;
	}

	.m-hero-track {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		/* 关键修改：移除以下两行，让滚动可以传递到父容器 */
		/* touch-action: pan-y; */
		/* overscroll-behavior-y: contain; */
		z-index: 999;
	}

	.m-hero-slide {
		flex: 0 0 auto;
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		margin-bottom: 2rem;
	}
	/* ✅ 新增：最后一张图片底部无间距 */
	.m-hero-slide:last-child {
	  margin-bottom: 0;
	}
	.m-hero-slide img {
		width: auto;
		max-width: 100%;
		height: auto;
		display: block;
	}

	/* 隐藏滚动条（可选） */
	.m-hero-track::-webkit-scrollbar,
	.m-hero-slide::-webkit-scrollbar {
		display: none;
	}

	.m-brand-img {
		position: absolute;
		top: 0rem;
		left: 0rem;
		width: 92%;
		pointer-events: none;
		mix-blend-mode: multiply;
	}

	.m-sub-hero img {
		width: 100%;
		height: 180rem;
		object-fit: cover;
	}

	.m-info {
		position: relative;
		padding: 28rem 25rem 8rem;
		display: flex;
		flex-direction: column;
		gap: 20rem;
	}

	.m-title {
		font-size: 16rem;
		font-weight: 500;
		text-underline-offset: 3rem;
	}

	.m-specs {
		display: flex;
		flex-direction: column;
		font-size: 10rem;
		font-weight: 500;
		margin-left: 6rem;
	}

	.m-spec-row {
		display: grid;
		grid-template-columns: 120rem 1fr;
		gap: 18rem;
		font-size: 10rem;
	}

	.m-spec-label {
		color: #000;
		font-weight: 500;
	}

	.m-spec-value {
		color: #000;
		font-weight: 500;
	}

	.m-note {
		font-size: 10rem;
		color: #000;
		margin-top: 15rem;
	}

	.m-actions {
		padding: 25rem 25rem 0rem;
	}

	.m-actions-bar {
		display: grid;
		grid-template-columns: 1fr 90rem;
	}

	.m-action-outline {
		padding: 10rem 12rem;
		background: #fff;
		color: #000;
		font-size: 12rem;
		text-align: left;
	}

	textarea:focus {
		outline: none;
	}

	.m-action-input {
		border: 0.5rem solid #000;
		border-right: none;
		background: #fff;
		color: #000;
		font-size: 10rem;
		text-align: left;
		width: 100%;
		resize: none;
		overflow: hidden;
		font-family: 'Apercu', sans-serif;
		min-height: 23rem !important;
		line-height: 23rem;
		padding-left: 10rem;
	}

	.m-action-solid {
		border: none;
		background: #000;
		color: #fff;
		font-size: 10rem;
		text-align: center;
		border: 0.5rem solid #000;
	}

	.page-content {
		/* 无固定高度，自然撑开，外部容器可滚动 */
	}

	.toggle-size-btn {
		display: inline-block;
		width: 20px;
		text-align: center;
		user-select: none;
		transition: transform 0.2s;
	}

	.toggle-size-btn:active {
		transform: scale(0.9);
	}
</style>